import React from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import OptionsCommon from 'components/show_drawing/redraw_form/options/OptionsCommon.jsx';
import ShowHideChildOptions from 'components/show_drawing/redraw_form/options/ShowHideChildOptions.jsx';

// A dropdown of admin-authored choices. The <select> value is a string token
// (option.select_choices[].value); the customer sees the localized description.
// The token is submitted under the option name and reaches the Formula engine
// unchanged, so formulas/rules can compare `optionname == 'token'`.
//
// Laid out like OptionLenghtWithUnit (compact label + a form-control that
// flex-grows) so the dropdown fills the row and its label lines up with the
// length/integer rows above it. It has no unit, so there is no trailing addon.
const OptionSelect = ({ id, drawing, option, unit, optionsUserChanged, addToOptionsUserChanged, setRedrawRequested, labelGroup = 'dimensions', inputName }) => {
  const submitName = inputName ?? option.name;
  const formattedValue = (value) => { return value }
  const redrawOnChange = true;
  const [isVisible, value, valueAutoCalculated, recommendedValue, onChange, showAbcHelperLine, changed, highlighted, d_input_add_on_ref, visibleSelectChoices] = OptionsCommon( { formattedValue, id, drawing, option, unit, optionsUserChanged, addToOptionsUserChanged, setRedrawRequested, redrawOnChange, labelGroup } )

  const choices = visibleSelectChoices || [];

  const getShowHideChildOptions = () => {
    if(option.children.length == 0) { return }
    return <ShowHideChildOptions id={id} option={option} />
  }

  if (!isVisible) { return <input type="hidden" name={submitName} value={value} /> }

  return (
    <div className={`${styles.row} ${styles.booleanGridItemWide}`}>
      <div className={`input-group ${highlighted ? styles.highlighted : ''}`} style={{ width: '100%' }}>
        <span className={`d_input_add_on input-group-addon input-group-addon-${window.locale} ${styles.input_add_on}`} ref={d_input_add_on_ref}>
          {option.presented_name}
        </span>

        <select
          name={submitName}
          value={value}
          onChange={onChange}
          className="drawing-option-input form-control"
          onFocus={showAbcHelperLine}
          >
          {choices.map( (choice) => <option key={choice.value} value={choice.value}> {choice.description} </option>  )}
        </select>
      </div>

      { getShowHideChildOptions() }
    </div>
    )
}

export default OptionSelect;
